import { makeAutoObservable } from 'mobx';
import apolloClient from 'api/apolloClient';
import { PaginationDTO } from 'types/general';
import { GENERATE_ZIP_FILE, GET_FILES, RESEND_FILE, SEND_FILE } from 'api/exchangeService';
import { ExchangeFile, FileExchangeService } from 'types/exchangeService';
import { FetchResult } from 'apollo-link';

export default class ExchangeStore {
  // eslint-disable-next-line class-methods-use-this
  async getFiles(
    from: string,
    to: string,
    sponsorId: string,
    status: string,
    path = '',
    page = 1,
  ): Promise<PaginationDTO<ExchangeFile>> {
    const res = await apolloClient.query<{ getFiles: PaginationDTO<ExchangeFile> }>({
      query: GET_FILES,
      fetchPolicy: 'no-cache',
      variables: { from, to, sponsorId, status, path, page },
    });
    return res.data.getFiles;
  }

  // eslint-disable-next-line class-methods-use-this
  async generateZipFile(
    from: string,
    to: string,
    sponsorId: string,
    status: string,
    path = '',
  ): Promise<FetchResult<{ generateZipFile: string }>> {
    return apolloClient.mutate<{ generateZipFile: string }>({
      mutation: GENERATE_ZIP_FILE,
      variables: { from, to, sponsorId, status, path },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async resendFile(fileId: string): Promise<FetchResult<{ resendFile: ExchangeFile }>> {
    return apolloClient.mutate<{ resendFile: ExchangeFile }>({
      mutation: RESEND_FILE,
      variables: { fileId },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async sendFile(
    fileId: string,
    sponsorId: string,
    service: FileExchangeService,
  ): Promise<FetchResult<{ sendFile: ExchangeFile }>> {
    return apolloClient.mutate<{ sendFile: ExchangeFile }>({
      mutation: SEND_FILE,
      variables: { fileId, sponsorId, service },
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
